import { connect } from 'react-redux';

import {
  initJiraRepoPage,
  hydrateJiraData,
  installAddonJiraTab,
  resetState,
} from 'src/redux/jira/actions';
import { getUpToSmallBreakpointState } from 'src/selectors/global-selectors';
import {
  getCurrentRepositoryFullSlug,
  getCurrentRepositoryOwnerName,
  getCurrentRepositoryWorkspace,
} from 'src/selectors/repository-selectors';
import { BucketState } from 'src/types/state';

import Page from '../components/jira-tab/page';

const mapDispatchToProps = {
  initJiraRepoPage,
  installJiraAddon: installAddonJiraTab,
  hydrateJiraData,
  resetState,
};
const mapStateToProps = (state: BucketState) => ({
  repositoryFullSlug: getCurrentRepositoryFullSlug(state) || '',
  workspace: getCurrentRepositoryWorkspace(state),
  workspaceName: getCurrentRepositoryOwnerName(state),
  isUpToSmallBreakpointActive: getUpToSmallBreakpointState(state),
  ...state.jira.jiraRepoPage,
});

export default connect(mapStateToProps, mapDispatchToProps)(Page);
